import React from "react";

export const AuthContext = React.createContext();
export const CartCountContext = React.createContext();
export const SweetAlertContext = React.createContext();
export const ShopFilterContext = React.createContext();
